import { createClient } from '@supabase/supabase-js'
import type { Database } from '@brew/shared'

const url = import.meta.env['VITE_SUPABASE_URL']
const anonKey = import.meta.env['VITE_SUPABASE_ANON_KEY']

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY fehlen. Siehe .env.example im Repo-Root.',
  )
}

/**
 * Der Client trägt den publishable key. Er ist öffentlich und darf es sein —
 * geschützt sind die Daten durch Row Level Security, nicht durch Geheimhaltung
 * des Keys. Der service_role key gehört ausschliesslich in den Fastify-Server.
 */
export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
